"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Application = exports.isUPLCApplicationBody = void 0;
var UPLCVar_1 = require("./UPLCVar/index.js");
var Lambda_1 = require("./Lambda.js");
var Builtin_1 = require("./Builtin/Builtin.js");
var Force_1 = require("./Force.js");
var bitstream_1 = require("@harmoniclabs/bitstream");
function isUPLCApplicationBody(uplc) {
    var proto = Object.getPrototypeOf(uplc);
    // only strict instances
    return (proto === UPLCVar_1.UPLCVar.prototype ||
        proto === Lambda_1.Lambda.prototype ||
        proto === Application.prototype ||
        proto === Force_1.Force.prototype ||
        proto === Builtin_1.Builtin.prototype);
}
exports.isUPLCApplicationBody = isUPLCApplicationBody;
var Application = /** @class */ (function () {
    function Application(func, arg) {
        this.funcTerm = func;
        this.argTerm = arg;
    }
    Object.defineProperty(Application, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("0011");
        },
        enumerable: false,
        configurable: true
    });
    Application.prototype.clone = function () {
        return new Application(this.funcTerm.clone(), this.argTerm.clone());
    };
    return Application;
}());
exports.Application = Application;
